import CoreAPI from "../Core/CoreAPI";
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
class LoyaltyAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_LOYALTY')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_LOYALTY')));

    return this.api;
  }

  /**
   * fetchOpportunities()
   * Lists the oportunities for a given policyholder
   *
   * @param {number} federalId - the federalId of the desired policyholder
   */
  async fetchOpportunities(federalId) {
    return await this.getAPI().getInstance().get(`/Opportunity/${federalId}`);
  }

  /**
   * showInterest()
   * Sends an email to the regional producer showing broker's interest in the opportunities
   *
   * @param {number} federalId - the federalId of the desired policyholder
   */
  async showInterest(federalId) {
    const data = {
      PolicyholderfederalId: federalId
    }
    return await this.getAPI().getInstance().post(`/mail`, data);
  }
}

const api = new LoyaltyAPI();
export default api;
